import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router';

@withRouter
export default class ContextMenu extends Component {
  static propTypes = {
    projectId: PropTypes.string,
    elementTypeId: PropTypes.string,
    link: PropTypes.string,
    onDelete: PropTypes.func,
    isLocked: PropTypes.bool,
  };

  state = {
    dropdownClosed: true,
  };

  onDropdownOptionClick = () => {
    this.setState({ dropdownClosed: true });
  };

  mouseLeaveEvent = () => {
    this.setState({ dropdownClosed: true });
  };

  toggleDropdownState = () => {
    this.setState({ dropdownClosed: !this.state.dropdownClosed });
  };

  _onDelete = () => {
    const { onDelete, elementTypeId } = this.props;

    onDelete(elementTypeId);
  };

  render() {
    const { projectId, elementTypeId, link, isLocked, router } = this.props;

    const dropdownState = this.state.dropdownClosed
      ? 'dropdown'
      : 'dropdown show';
    const elementsByTypeUrl = `/project/${projectId}/settings/element-type/${elementTypeId}/elements`;

    return (
      <div
        className={dropdownState}
        style={{ marginTop: 5, marginBottom: 5, float: 'right' }}
      >
        <i
          onClick={this.toggleDropdownState}
          className="fa fa-bars"
          style={{ marginRight: 5 }}
          id="dropdownMenu2"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        />
        <div
          className="dropdown-menu"
          onMouseLeave={this.mouseLeaveEvent}
          aria-labelledby="dropdownMenu1"
        >
          <a onClick={() => router.push(link)} className="dropdown-item">
            View
          </a>
          <a onClick={() => router.push(elementsByTypeUrl)} className="dropdown-item">
            View elements of this type
          </a>
          {!isLocked && (
            <a onClick={this._onDelete} className="dropdown-item">
              Delete
            </a>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/cards/contextMenus/elementTypeContext.js